function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.473 1.045a1.7 1.7 0 013.133 0l1.233 2.964a.565.565 0 00.477.347l3.2.257a1.7 1.7 0 01.968 2.978l-2.439 2.09a.565.565 0 00-.182.56l.745 3.123a1.7 1.7 0 01-2.534 1.842l-2.741-1.674a.561.561 0 00-.588 0l-2.741 1.674a1.7 1.7 0 01-2.534-1.842l.744-3.123a.562.562 0 00-.181-.56L.594 7.591a1.7 1.7 0 01.968-2.978l3.2-.257a.567.567 0 00.477-.347zm2.089.434a.565.565 0 00-1.044 0L6.285 4.444a1.7 1.7 0 01-1.431 1.039l-3.2.257a.565.565 0 00-.322.992l2.438 2.09a1.7 1.7 0 01.547 1.681l-.745 3.124a.565.565 0 00.845.613l2.74-1.674a1.7 1.7 0 011.768 0l2.741 1.674a.565.565 0 00.844-.613l-.746-3.124a1.7 1.7 0 01.547-1.681l2.439-2.09a.565.565 0 00-.323-.992l-3.2-.257a1.7 1.7 0 01-1.431-1.039z",
  fillRule: "evenodd"
});

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.079 15.459",
    className: "w-full h-full fill-current"
  }, props), _ref);
}

export default SvgStar;